import React, { useState } from 'react';
import './Navbar.css';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useDropdownClose } from '../hooks/useDropdownClose';
import logo from '../assets/cosa_logo.png';
import { Endgeräte, Gateways, Dashboard, Mitteilungen, Import, Profil } from '../icons';

const Navbar = ({ onLogout, onToggleSidebar, showSidebarToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  useDropdownClose(profileMenuOpen, () => setProfileMenuOpen(false), '.profile-dropdown');

  const navItems = [
    { label: 'Endgeräte', icon: <Endgeräte />, path: '/devices' },
    { label: 'Gateways', icon: <Gateways />, path: '/gateways', disabled: true },
    { label: 'Dashboards', icon: <Dashboard />, path: '/dashboards' },
    { label: 'Meldungen', icon: <Mitteilungen />, path: '/notifications' },
    { label: 'Externe Daten', icon: <Import />, path: '/external-data', disabled: true },
    { label: 'Profil', icon: <Profil />, path: null, dropdown: true }
  ];

  // Kein navigate('/login') hinterher. onLogout startet die Weiterleitung zu
  // Keycloak, die erst asynchron greift; ein React-Wechsel auf /login kaeme
  // vorher zum Zug, und die Loginseite verbraucht dabei den "abgemeldet"-Merker
  // (Login.js). Bei der Rueckkehr von Keycloak waere er weg und die Seite
  // schickte sofort wieder zur Anmeldemaske. Den Rueckweg bestimmt
  // post_logout_redirect_uri in oidcConfig.
  const handleLogout = () => {
    setProfileMenuOpen(false);
    onLogout();
  };

  const handleNavClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        {showSidebarToggle && (
          <button className="sidebar-toggle" onClick={onToggleSidebar} aria-label="Seitenleiste umschalten">
            ☰
          </button>
        )}
        <Link to="/home" className="navbar-logo-link">
          <img src={logo} alt="COSA Logo" className="navbar-logo" />
        </Link>
      </div>

      <div className="navbar-center">
        <div className="nav-items">
          {navItems.map((item, index) => {
            const isActive = item.path && (
              location.pathname.startsWith(item.path) ||
              (item.path === '/devices' && (location.pathname.startsWith('/device-groups') || location.pathname.startsWith('/add-device') || location.pathname.startsWith('/register-device') || location.pathname.startsWith('/overview-added-devices'))) ||
              (item.path === '/notifications' && (location.pathname.startsWith('/alarms') || location.pathname.startsWith('/alarm-rules') || location.pathname.startsWith('/new-alarm-rule'))) ||
              // Treat singular `/dashboard` routes as active for the `/dashboards` nav item
              (item.path === '/dashboards' && location.pathname.startsWith('/dashboard'))
            );
            return (
              <div
                key={index}
                className={`nav-item ${item.dropdown ? 'profile-item' : ''} ${isActive ? 'active' : ''}`}
              >
                {!item.dropdown ? (
                  <button
                    className="nav-button"
                    onClick={() => !item.disabled && handleNavClick(item.path)}
                    title={item.label}
                    aria-label={item.label}
                    disabled={item.disabled || false}
                  >
                    <span className="nav-icon">{item.icon }</span>
                    <span className="nav-label">{item.label}</span>
                  </button>
                ) : (
                  <div className="profile-dropdown">
                    <button
                      className="nav-button"
                      onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                      title={item.label}
                    >
                      <span className="nav-icon">{item.icon }</span>
                      <span className="nav-label">{item.label}</span>
                    </button>
                    {profileMenuOpen && (
                      <div className="dropdown-menu">
                        <button
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          Abmelden
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
